import { lazyRouteComponent } from "@tanstack/react-router";
import type { At } from "../../router";

export const SettingsRoutes = (at: At) => [
  at("/settings", lazyRouteComponent(() => import("./Settings"), "SettingsIndex")),
  at("/settings/profile", lazyRouteComponent(() => import("./Settings"), "ProfileSettings")),
  at("/settings/notifications", lazyRouteComponent(() => import("./Settings"), "NotificationSettings")),
  at("/settings/workspace", lazyRouteComponent(() => import("./Settings"), "WorkspaceSettings")),
  at("/settings/team", lazyRouteComponent(() => import("./Settings"), "TeamSettings")),
  at("/settings/people", lazyRouteComponent(() => import("./People"), "PeopleSettings")),
  at("/settings/modules", lazyRouteComponent(() => import("./Settings"), "ModulesSettings")),
  at("/settings/billing", lazyRouteComponent(() => import("./Settings"), "BillingSettings")),
  at("/settings/ai", lazyRouteComponent(() => import("./Settings"), "AiSettings")),
  at("/settings/sdi", lazyRouteComponent(() => import("./Settings"), "SdiSettings")),
  at("/settings/mcp", lazyRouteComponent(() => import("./Mcp"), "McpSettings")),
  at("/settings/api-keys", lazyRouteComponent(() => import("./Settings"), "ApiKeysSettings")),
  at("/settings/audit", lazyRouteComponent(() => import("./Settings"), "AuditSettings")),
  at("/settings/email", lazyRouteComponent(() => import("./Email"), "EmailSenderSettings")),
  at("/settings/mailbox", lazyRouteComponent(() => import("./Email"), "MailboxSettings")),
  at("/settings/email-log", lazyRouteComponent(() => import("./Email"), "EmailLogSettings")),
];
